import { Modal } from "antd"
import "./style.scss"
import { useState } from "react";
const UiProfileModel = ({
  open,
  onCancel,
  imageUrl,
  ...restProps
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <>
    <img
      src={imageUrl}
      alt="loading"
      style={{
        width: "50px",
        height: "50px",
        borderRadius: "50%",
        objectFit: "cover",
        cursor: "pointer",
        aspectRatio: "1 / 1"
      }}
      onClick={() => setIsOpen(true)}
    /> <Modal className="custom-image-modal" open={isOpen} onCancel={() => setIsOpen(false)} {...restProps} footer={null} closeIcon={<span style={{ fontSize: 24, color: "#fff" }}>×</span>}>
      <div style={{ padding: "20px 0px" }}>
        <img src={imageUrl} alt="preview" style={{ width: "100%", height: "auto", borderRadius: "8px", objectFit: "cover" }} onClick={(event) => event?.stopPropagation()} />
      </div>
    </Modal>
  </>
};
export default UiProfileModel